import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const createStore = (fn, name = '') => {
  if (IS_DEV_SERVER) {
    return create(devtools(fn, { name }));
  }

  return create(fn);
};
